var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30.722",
        height: "14.884",
        viewBox: "636.669 334.558 30.722 14.884",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M667.04 341.15h-.002l-6.27-6.242a1.2 1.2 0 1 0-1.694 1.701l4.21 4.19H637.87a1.2 1.2 0 0 0 0 2.401h25.415l-4.21 4.19a1.2 1.2 0 0 0 1.694 1.702l6.27-6.241.001-.001c.47-.47.469-1.232 0-1.7Z",
          fill: _vm.color || "#aaa",
          "fill-rule": "evenodd",
          "data-name": "1",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }